import * as React from 'react'

import { Badge } from '../../../Components/Badge';
import { Card, CardContent } from '../../../Components/Card';
import Loader from '../../../Components/Loader';
import { ScrollArea } from '../../../Components/ScrollArea';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../../Components/Table';
import { AdminIcon } from '../../../Icons/AdminIcon';
import { DiscountType } from '../../../Types/PromoCodeTypes';
import { Button } from '../../../Components/Button';
interface CampainCardViewProps{
    isLoading:boolean;
    promoCodes:any[];
    onCreate:() => void;
    onEdit:(promo:any) => void;
    onDelete:(id:number) => void;
}
export const CampainCardView = ({isLoading,promoCodes,onCreate,onEdit,onDelete}:CampainCardViewProps) => {
    return(

        <Card className="admin-surface-card admin-campain-list-card" disableHover>
              <div className="admin-campain-list-header">
                <div>
                  <h3>Alla kampanjkoder</h3>
                  <p>Hantera, uppdatera och rensa kampanjer utan modaler.</p>
                </div>
                <Button className='submit-button' text={<span style={{display:'flex',justifyContent:'center',gap:8}}><AdminIcon.PlusSign width={16} height={16} fill='white'/>Skapa ny kod</span>} onClick={onCreate}/>
              </div>
              <CardContent>
                <ScrollArea className="h-[500px]">
                  {isLoading ? (
                    <Loader loaderSize='XLARGE' bgColor='black'/>
                  ): (
                     <Table >
                    <TableHeader>
                      <TableRow>
                        <TableHead>Kod</TableHead>
                        <TableHead>Beskrivning</TableHead>
                        <TableHead>Rabatt</TableHead>
                        {/* <TableHead>Period</TableHead> */}
                        <TableHead>Användning</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead className="text-right">Åtgärder</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {promoCodes.map((code) => (
                        <TableRow key={code.id}>
                          <TableCell className="font-mono font-semibold">{code.code}</TableCell>
                          <TableCell className="max-w-xs truncate">{code.description}</TableCell>
                          <TableCell>
                            {code.discountType === DiscountType.Percentage
                              ? `${code.discountValue}%`
                              : `${code.discountValue} kr`}
                            {code.maxDiscountAmount && (
                              <span className="text-xs text-muted-foreground block">
                                Max: {code.maxDiscountAmount} kr
                              </span>
                            )}
                          </TableCell>
                          <TableCell>
                            {code.usageCount}
                            {code.usageLimit && ` / ${code.usageLimit}`}
                          </TableCell>
                          <TableCell>
                            {code.isActive ? (
                              <Badge className="bg-green-500">Aktiv</Badge>
                            ) : (
                              <Badge variant="secondary">Inaktiv</Badge>
                            )}
                          </TableCell>
                          <TableCell className="text-right" style={{display:'flex',gap:4}}>
                      
                              <button
                                
                                className='bla-cell-button-one'
                                onClick={() => {
                                  onEdit(code);
                                }}
                                
                              ><AdminIcon.EditPencil width={14} height={14} fill='hsl(var(--primary))'/></button>
                                
                              
                              <button
                                className='bla-cell-button-one'
                                onClick={() => onDelete(code.id)}
                                //text={}
                              ><AdminIcon.Trashcan width={14} height={14} fill='hsl(var(--primary))'/></button>
                               
                            
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  )}
                      
                </ScrollArea>
              </CardContent>
            </Card>
    );
}
